module.exports = __webpack_public_path__ + "assets/img/2.f4d6dcc9.jpg";